window.addEventListener('DOMContentLoaded', () => {
    // ブラウザ別 ========================================================================================================
    detectIOSChrome();
    detectMacSafari();

    // 動画系 ===========================================================================================================
    // safariで動画が再生されないことがあるためjsでsrc挿入
    setupKvVideo();
    setupSceneVideos();
    initSceneVideoPlayback();

    // instagramセクションの背景に動画を映すための処理
    initHeroSceneState();

    // スクロール系 ======================================================================================================
    // スクロールで順次表示
    initFadeScrollAnimation();

    // Scenes
    initScenesAnimation();

    // Nav系 ===========================================================================================================
    // navの大きさ変更
    initNavResize();

    // nav内のsvgの色変更
    initNavSpy();

    // 表示系 ===========================================================================================================
    // タイミングを合わせて下から上にフェードイン
    initSyncFade();

    // UI ==============================================================================================================
    // modal内のswiper
    initModalSwiperFeatures();

    // カーソルアニメーション
    initCursor();

    // ボタンの連続クリックの無効化
    initClickProtection();

    // PC時のページ読み込みの瞬間にシーンが映り込んでしまう（position: sticky;bottom: 0;の影響）。
    // 対策としてhtmlの読み込み後のタイミングにjs-na26-readyを付与して、動画が表示された後にシーンを表示させる。
    document.documentElement.classList.add('js-na26-ready');

    // 初回読み込み時に hash が付いている場合の補正
    fixInitialHashScroll();
});

function detectIOSChrome() {
    const ua = navigator.userAgent;

    const isIOS =
        /iPhone|iPad|iPod/i.test(ua) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    const isChrome = /CriOS/i.test(ua);

    if (isIOS && isChrome) {
        document.body.classList.add('is-ios-chrome');
    }
}

function detectMacSafari() {
    const ua = navigator.userAgent;
    const isMac = /Macintosh/.test(ua);
    const isSafari = /Safari/.test(ua) && !/Chrome|CriOS|Edg|OPR/.test(ua);

    if (isMac && isSafari) {
        document.documentElement.classList.add('is-mac-safari');
    }
}

function setupKvVideo() {
    const video = document.getElementById('js-kvVideo');
    if (!video) return;

    const isSp = window.innerWidth <= 1023;

    const src = isSp
        ? 'https://cdn.shopify.com/videos/c/o/v/0d2ea3a99a8b492ca3b6b37aa2f4cb44.mp4'
        : 'https://cdn.shopify.com/videos/c/o/v/5b903727da314df78578048b55aab7a5.mp4';

    video.src = src;

    video.load();

    // iOS対策：強制再生
    const playPromise = video.play();
    if (playPromise !== undefined) {
        playPromise.catch(() => {
            // 失敗時リトライ
            setTimeout(() => {
                video.play();
            }, 300);
        });
    }
}

function setupSceneVideos() {
    const isSp = window.innerWidth <= 1023;

    const videoMap = {
        morning: {
            sp: 'https://cdn.shopify.com/videos/c/o/v/6b98cdeec0a14394ae3bdc726c47809b.mp4',
            pc: 'https://cdn.shopify.com/videos/c/o/v/c0e2ddecb3f74b9094f570fd28e7ce8d.mp4'
        },
        evening: {
            sp: 'https://cdn.shopify.com/videos/c/o/v/dd6f47d39ad74e4ab8a4e5ead1d3c562.mp4',
            pc: 'https://cdn.shopify.com/videos/c/o/v/bdb05ed652b84694985070be901c9b7d.mp4'
        },
        night: {
            sp: 'https://cdn.shopify.com/videos/c/o/v/a479dce838744171be4665ddbd2afecf.mp4',
            pc: 'https://cdn.shopify.com/videos/c/o/v/d04cdee02b2144648cb3a66d8d1fc741.mp4'
        }
    };

    document.querySelectorAll('.js-na26SceneMovie').forEach(video => {
        const key = video.dataset.sceneVideo;
        if (!key || !videoMap[key]) return;

        const src = isSp ? videoMap[key].sp : videoMap[key].pc;

        if (video.getAttribute('src') !== src) {
            video.src = src;
            video.load();
        }
    });
}

function initSceneVideoPlayback() {
    const videos = document.querySelectorAll('.js-na26SceneMovie');
    if (!videos.length) return;

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const video = entry.target;

            if (entry.isIntersecting) {
                const playPromise = video.play();
                if (playPromise !== undefined) {
                    playPromise.catch(() => {});
                }
            } else {
                video.pause();
            }
        });
    }, {
        threshold: 0.15
    });

    videos.forEach(video => observer.observe(video));
}

function initHeroSceneState() {
    const heroEl = document.getElementById('js-na26Hero');
    const triggerEl = document.getElementById('wall');
    const scenes = document.querySelectorAll('.js-na26Scene');

    if (!heroEl || !triggerEl) return;

    let raf = 0;

    const check = () => {
        raf = 0;

        const isPc = window.innerWidth >= 1024;

        // SPではこの処理をしない
        if (!isPc) {
            heroEl.classList.remove('js-na26Hero--sticky100');
            scenes.forEach(scene => {
                scene.classList.remove('js-na26Scene--hide');
            });
            return;
        }

        const rect = triggerEl.getBoundingClientRect();
        const hasReachedTrigger = rect.bottom < window.innerHeight;

        if (hasReachedTrigger) {
            heroEl.classList.add('js-na26Hero--sticky100');
            scenes.forEach(scene => {
                scene.classList.add('js-na26Scene--hide');
            });
        } else {
            heroEl.classList.remove('js-na26Hero--sticky100');
            scenes.forEach(scene => {
                scene.classList.remove('js-na26Scene--hide');
            });
        }
    };

    const onScroll = () => {
        if (raf) return;
        raf = requestAnimationFrame(check);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', check);
    check();
}

function initFadeScrollAnimation() {
    let fadeTicking = false;

    function handleFadeScroll() {
        const scrollAnimateTxt = document.querySelectorAll('.js-na26-fadeTxt');
        const scrollAnimatePic = document.querySelectorAll('.js-na26-fadePic');
        const windowHeight = window.innerHeight;

        scrollAnimateTxt.forEach(element => {
            const elementTop = element.getBoundingClientRect().top;
            if (elementTop < windowHeight) {
                element.classList.add('js-show');
            }
        });

        scrollAnimatePic.forEach(element => {
            const elementTop = element.getBoundingClientRect().top;
            if (elementTop < windowHeight) {
                element.classList.add('js-show');
            }
        });

        fadeTicking = false;
    }

    function onScrollFade() {
        if (!fadeTicking) {
            requestAnimationFrame(handleFadeScroll);
            fadeTicking = true;
        }
    }

    handleFadeScroll();
    window.addEventListener('scroll', onScrollFade, { passive: true });
    window.addEventListener('resize', handleFadeScroll);
}

function initScenesAnimation() {
    const scenes = document.querySelectorAll('.js-na26Scene');
    if (!scenes.length) return;

    let sceneTicking = false;
    let lastScrollY = window.scrollY;
    let scrollDirection = 'down';

    const showRafs = new WeakMap();

    // ---------------------------------
    // デバイス判定
    // ---------------------------------
    const ua = navigator.userAgent;

    const isIOS =
        /iPhone|iPad|iPod/i.test(ua) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    const isIOSChrome = isIOS && /CriOS/i.test(ua);
    const isIOSSafari =
        isIOS &&
        /Safari/i.test(ua) &&
        !/CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua);

    // ---------------------------------
    // SP用：減速関連
    // ---------------------------------
    let spSlowDownUntil = 0;
    let spSlowDownSceneId = '';
    let spSlowDownTriggeredMap = new Map();

    // ページ内リンク移動中は減速を無効化
    let spSlowDownDisabledUntil = 0;

    // タップ救済
    // fadeout / copy / undefined で管理
    let spAssistModeMap = new Map();

    // タップ直後の click 二重発火防止
    let spLastAssistAt = 0;

    function cancelShowRaf(textEl) {
        const rafIds = showRafs.get(textEl);
        if (!rafIds) return;
        rafIds.forEach(id => cancelAnimationFrame(id));
        showRafs.delete(textEl);
    }

    function updateScrollDirection() {
        const currentScrollY = window.scrollY;

        if (currentScrollY > lastScrollY) {
            scrollDirection = 'down';
        } else if (currentScrollY < lastScrollY) {
            scrollDirection = 'up';
        }

        lastScrollY = currentScrollY;
    }

    function canTriggerSpSlowDown(sceneId) {
        return !spSlowDownTriggeredMap.get(sceneId);
    }

    function markSpSlowDownTriggered(sceneId) {
        spSlowDownTriggeredMap.set(sceneId, true);
    }

    function clearSpSlowDownTriggered(sceneId) {
        spSlowDownTriggeredMap.delete(sceneId);
    }

    function resetSpSlowDown() {
        spSlowDownUntil = 0;
        spSlowDownSceneId = '';
    }

    // ---------------------------------
    // SP：タップ救済
    // タップごとに fadeout / copy を切り替える
    // ---------------------------------
    function enableSpAssistTrigger() {
        scenes.forEach(scene => {
            const sceneId = scene.dataset.sceneId;
            if (!sceneId) return;

            let touchStartY = 0;
            let touchMoved = false;
            let startedOnModalButton = false;

            function isModalButtonTarget(target) {
                return !!(target && target.closest && target.closest('.js-c-modalOpen'));
            }

            function triggerAssist() {
                const now = performance.now();

                // touchend → click の二重発火を抑制
                if (now - spLastAssistAt < 320) return;
                spLastAssistAt = now;

                const currentMode = spAssistModeMap.get(sceneId);

                if (currentMode === 'fadeout') {
                    spAssistModeMap.set(sceneId, 'copy');
                } else {
                    spAssistModeMap.set(sceneId, 'fadeout');
                }

                handleScenes();
            }

            scene.addEventListener('touchstart', (e) => {
                if (window.innerWidth >= 1024) return;
                if (!e.touches || !e.touches.length) return;

                startedOnModalButton = isModalButtonTarget(e.target);
                touchStartY = e.touches[0].clientY;
                touchMoved = false;
            }, { passive: true });

            scene.addEventListener('touchmove', (e) => {
                if (window.innerWidth >= 1024) return;
                if (!e.touches || !e.touches.length) return;

                const diff = Math.abs(e.touches[0].clientY - touchStartY);

                // 強いスクロールはタップ扱いしない
                if (diff > 14) {
                    touchMoved = true;
                }
            }, { passive: true });

            scene.addEventListener('touchend', (e) => {
                if (window.innerWidth >= 1024) return;

                // モーダルボタン上のタッチはシーン切替しない
                if (startedOnModalButton || isModalButtonTarget(e.target)) return;

                if (!touchMoved) {
                    triggerAssist();
                }
            }, { passive: true });

            // Chrome検証画面 / PCでSP確認用
            scene.addEventListener('click', (e) => {
                if (window.innerWidth >= 1024) return;

                // モーダルボタン上のクリックはシーン切替しない
                if (isModalButtonTarget(e.target)) return;

                triggerAssist();
            });
        });
    }

    // ---------------------------------
    // SP処理
    // ---------------------------------
    function updateScenesSp() {
        const viewportH = window.innerHeight;

        // iPhone Safariだけ減速あり
        const IOS_SAFARI_CONFIG = {
            SP_BUTTON_PHASE_START: 0.6,
            SP_SLOWDOWN_TRIGGER: 0.7,
            SP_SLOWDOWN_DURATION: 800,
            SP_SLOWDOWN_BACK_PX: 20
        };

        // iPhone Chrome は減速なし
        const IOS_CHROME_CONFIG = {
            SP_BUTTON_PHASE_START: 0.6,
            SP_SLOWDOWN_TRIGGER: 999,
            SP_SLOWDOWN_DURATION: 0,
            SP_SLOWDOWN_BACK_PX: 0
        };

        // Android も減速なし
        const ANDROID_CONFIG = {
            SP_BUTTON_PHASE_START: 0.18,
            SP_SLOWDOWN_TRIGGER: 999,
            SP_SLOWDOWN_DURATION: 0,
            SP_SLOWDOWN_BACK_PX: 0
        };

        const config = isIOSSafari
            ? IOS_SAFARI_CONFIG
            : isIOSChrome
                ? IOS_CHROME_CONFIG
                : ANDROID_CONFIG;

        const {
            SP_BUTTON_PHASE_START,
            SP_SLOWDOWN_TRIGGER,
            SP_SLOWDOWN_DURATION,
            SP_SLOWDOWN_BACK_PX
        } = config;

        const now = performance.now();

        if (scrollDirection === 'up' && spSlowDownSceneId) {
            resetSpSlowDown();
        }

        if (spSlowDownUntil && now >= spSlowDownUntil) {
            resetSpSlowDown();
        }

        scenes.forEach(scene => {
            const sceneId = scene.dataset.sceneId || '';
            const rect = scene.getBoundingClientRect();
            const totalScroll = scene.offsetHeight - viewportH;

            let progress = 0;

            if (totalScroll > 0) {
                const currentScroll = Math.min(
                    Math.max(-rect.top, 0),
                    totalScroll
                );
                progress = currentScroll / totalScroll;
            }

            if (progress < 0.005) {
                clearSpSlowDownTriggered(sceneId);
            }

            if (rect.bottom <= 0 || rect.top >= viewportH) {
                spAssistModeMap.delete(sceneId);
            }

            if (
                spSlowDownSceneId === sceneId &&
                (rect.bottom <= viewportH * 0.2 || rect.top >= viewportH)
            ) {
                resetSpSlowDown();
            }

            const isSlowDownActive =
                isIOSSafari &&
                scrollDirection === 'down' &&
                spSlowDownSceneId === sceneId &&
                now < spSlowDownUntil &&
                rect.top <= 0 &&
                rect.bottom > viewportH * 0.2;

            const assistMode = spAssistModeMap.get(sceneId);

            let shouldFadeout =
                progress >= SP_BUTTON_PHASE_START ||
                isSlowDownActive;

            if (assistMode === 'fadeout') {
                shouldFadeout = true;
            }

            if (assistMode === 'copy') {
                shouldFadeout = false;
            }

            // iPhone Safariだけ減速
            if (
                isIOSSafari &&
                now >= spSlowDownDisabledUntil &&
                scrollDirection === 'down' &&
                sceneId &&
                !spSlowDownSceneId &&
                canTriggerSpSlowDown(sceneId) &&
                progress >= SP_SLOWDOWN_TRIGGER &&
                rect.top <= 0 &&
                rect.bottom > viewportH * 0.2
            ) {
                spSlowDownSceneId = sceneId;
                spSlowDownUntil = now + SP_SLOWDOWN_DURATION;
                markSpSlowDownTriggered(sceneId);

                const targetY = Math.max(window.scrollY - SP_SLOWDOWN_BACK_PX, 0);
                window.scrollTo(0, targetY);
            }

            scene.classList.toggle('is-fadeout', shouldFadeout);
            scene.dataset.wasFadeout = shouldFadeout ? 'true' : 'false';
        });
    }

    // ---------------------------------
    // PC処理
    // ---------------------------------
    function updateSceneFadeoutState(viewportH) {
        scenes.forEach(scene => {
            const sceneId = scene.dataset.sceneId;
            if (!sceneId) {
                scene.classList.remove('is-fadeout');
                scene.dataset.wasFadeout = 'false';
                return;
            }

            const trigger = document.querySelector(
                `.js-na26SceneTrigger[data-fadeout-target="${sceneId}"]`
            );

            if (!trigger) {
                scene.classList.remove('is-fadeout');
                scene.dataset.wasFadeout = 'false';
                return;
            }

            const triggerRect = trigger.getBoundingClientRect();

            const shouldFadeout = triggerRect.top <= viewportH * 0.06;

            scene.classList.toggle('is-fadeout', shouldFadeout);
            scene.dataset.wasFadeout = shouldFadeout ? 'true' : 'false';
        });
    }

    function getSceneCopyState(scene, refs, viewportH) {
        const sceneId = scene.dataset.sceneId;
        const sceneRect = scene.getBoundingClientRect();

        const downShowLine = 0;
        const upShowLine = viewportH * 0.2;
        const showLine = scrollDirection === 'up' ? upShowLine : downShowLine;

        let shouldShow = false;

        if (sceneId === 'morning') {
            const eveningRect = refs.eveningScene
                ? refs.eveningScene.getBoundingClientRect()
                : null;

            const hasEnteredMorning = true;
            const hasClearedEvening = eveningRect ? eveningRect.top > showLine : true;

            shouldShow = hasEnteredMorning && hasClearedEvening;
        }

        if (sceneId === 'evening') {
            const nightRect = refs.nightScene
                ? refs.nightScene.getBoundingClientRect()
                : null;

            const hasEnteredEvening = sceneRect.top <= 0;
            const hasClearedNight = nightRect ? nightRect.top > showLine : true;

            shouldShow = hasEnteredEvening && hasClearedNight;
        }

        if (sceneId === 'night') {
            const nightTriggerRect = refs.nightTrigger
                ? refs.nightTrigger.getBoundingClientRect()
                : null;

            const hasEnteredNight = sceneRect.top <= 0;
            const hasClearedNightEnd = nightTriggerRect
                ? nightTriggerRect.top > showLine
                : true;

            shouldShow = hasEnteredNight && hasClearedNightEnd;
        }

        return { shouldShow };
    }

    function applyCopyState(scene, textEl, shouldShow) {
        if (!textEl) return;

        const isSceneFadeout = scene.classList.contains('is-fadeout');
        const enterClass =
            scrollDirection === 'up' ? 'is-copy-enter-up' : 'is-copy-enter-down';

        cancelShowRaf(textEl);

        if (isSceneFadeout) {
            textEl.classList.remove(
                'is-copy-hide',
                'is-copy-enter-down',
                'is-copy-enter-up'
            );
            textEl.classList.add('is-copy-show');
            return;
        }

        if (shouldShow) {
            if (textEl.classList.contains('is-copy-show')) return;

            textEl.classList.remove(
                'is-copy-hide',
                'is-copy-show',
                'is-copy-enter-down',
                'is-copy-enter-up'
            );

            textEl.classList.add(enterClass);

            const raf1 = requestAnimationFrame(() => {
                const raf2 = requestAnimationFrame(() => {
                    textEl.classList.remove(
                        'is-copy-hide',
                        'is-copy-enter-down',
                        'is-copy-enter-up'
                    );
                    textEl.classList.add('is-copy-show');
                    showRafs.delete(textEl);
                });

                showRafs.set(textEl, [raf1, raf2]);
            });

            showRafs.set(textEl, [raf1]);
            return;
        }

        textEl.classList.remove(
            'is-copy-show',
            'is-copy-enter-down',
            'is-copy-enter-up'
        );
        textEl.classList.add('is-copy-hide');
    }

    function updateScenesPc() {
        const viewportH = window.innerHeight;

        const refs = {
            heroEl: document.getElementById('js-na26Hero'),
            eveningScene: document.querySelector('.js-na26Scene[data-scene-id="evening"]'),
            nightScene: document.querySelector('.js-na26Scene[data-scene-id="night"]'),
            nightTrigger: document.querySelector('.js-na26SceneTrigger[data-fadeout-target="night"]')
        };

        updateSceneFadeoutState(viewportH);

        scenes.forEach(scene => {
            const sceneId = scene.dataset.sceneId;
            if (!sceneId) return;

            const textEl = scene.querySelector('.na26Scene__in__txt');
            if (!textEl) return;

            const { shouldShow } = getSceneCopyState(scene, refs, viewportH);
            applyCopyState(scene, textEl, shouldShow);
        });
    }

    // ---------------------------------
    // メインループ
    // ---------------------------------
    function handleScenes() {
        updateScrollDirection();

        if (window.innerWidth >= 1024) {
            updateScenesPc();
        } else {
            updateScenesSp();
        }

        sceneTicking = false;
    }

    function onScrollScenes() {
        if (!sceneTicking) {
            requestAnimationFrame(handleScenes);
            sceneTicking = true;
        }
    }

    // ---------------------------------
    // イベント
    // ---------------------------------
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', () => {
            spSlowDownDisabledUntil = performance.now() + 1200;
            resetSpSlowDown();
        });
    });

    window.addEventListener('hashchange', () => {
        spSlowDownDisabledUntil = performance.now() + 1200;
        resetSpSlowDown();
    });

    if (window.location.hash) {
        spSlowDownDisabledUntil = performance.now() + 1800;
        resetSpSlowDown();
    }

    enableSpAssistTrigger();

    handleScenes();

    window.addEventListener('scroll', onScrollScenes, { passive: true });

    window.addEventListener('resize', () => {
        resetSpSlowDown();
        spSlowDownTriggeredMap = new Map();
        spAssistModeMap = new Map();
        handleScenes();
    });
}

function initNavResize() {
    const targetSection = document.getElementById('js-na26Hero__concept');
    const wallSection = document.getElementById('wall');
    const nav = document.getElementById('js-na26Nav');

    if (!targetSection || !wallSection || !nav) return;

    function updateNavState() {
        const targetRect = targetSection.getBoundingClientRect();
        const wallRect = wallSection.getBoundingClientRect();

        const triggerOffset = 120; // 数字を大きくするとsmallになるのが遅くなる
        const triggerLine = window.innerHeight - triggerOffset;

        const hasPassedConcept = targetRect.top <= triggerLine;
        const isAboveConcept = targetRect.top > triggerLine;

        // wallの終端が画面下端に来たら、そこでnavを消す
        const hasReachedWallEnd = wallRect.bottom <= window.innerHeight;

        // wall終端以降は絶対にnavを表示しない
        if (hasReachedWallEnd) {
            nav.classList.add('is-hidden');
            nav.classList.add('js-na26Nav--small');
            return;
        }

        // wall終端より前だけ通常制御
        nav.classList.remove('is-hidden');

        if (isAboveConcept) {
            nav.classList.remove('js-na26Nav--small');
        } else if (hasPassedConcept) {
            nav.classList.add('js-na26Nav--small');
        }
    }

    let navResizeRaf = 0;

    function onScrollNavResize() {
        if (navResizeRaf) return;
        navResizeRaf = requestAnimationFrame(() => {
            updateNavState();
            navResizeRaf = 0;
        });
    }

    window.addEventListener('scroll', onScrollNavResize, { passive: true });
    window.addEventListener('resize', updateNavState);
    updateNavState();
}

function initNavSpy() {
    const nav = document.getElementById('js-na26Nav');
    if (!nav) return;

    const sections = Array.from(document.querySelectorAll('.js-na26Cat[id]'));
    if (!sections.length) return;

    const fills = new Map();

    nav.querySelectorAll('a[data-id]').forEach(a => {
        const id = a.dataset.id;
        const fill = a.querySelector('.js-na26Nav__a__in__icn__fill');
        if (id && fill) fills.set(id, fill);
    });

    const clear = () => {
        fills.forEach(el => el.classList.remove('is-active'));
    };

    const activate = id => {
        const fill = fills.get(id);
        if (!fill) return;
        clear();
        fill.classList.add('is-active');
    };

    const spy = () => {
        let currentId = null;

        sections.forEach(sec => {
            const rect = sec.getBoundingClientRect();

            // section が表示領域に入っていたら active 候補
            if (rect.top < window.innerHeight && rect.bottom > 0) {
                currentId = sec.id;
            }
        });

        if (!currentId) {
            clear();
            return;
        }

        activate(currentId);
    };

    let navSpyRaf = 0;

    const onScrollNavSpy = () => {
        if (navSpyRaf) cancelAnimationFrame(navSpyRaf);
        navSpyRaf = requestAnimationFrame(spy);
    };

    spy();
    window.addEventListener('scroll', onScrollNavSpy, { passive: true });
    window.addEventListener('resize', () => requestAnimationFrame(spy));
    window.addEventListener('hashchange', () => setTimeout(spy, 0));

    nav.addEventListener('click', e => {
        const a = e.target.closest('a[data-id]');
        if (!a) return;
        activate(a.dataset.id);
    });
}

function initSyncFade() {
    const svCovers = document.querySelectorAll('.js-na26-syncFade');
    if (!svCovers.length) return;

    const svObserver = new IntersectionObserver(
        entries => {
            entries.forEach(entry => {
                const svCover = entry.target;
                const svTexts = svCover.querySelectorAll('.js-na26-syncFade__txt');
                const svPics = svCover.querySelectorAll('.js-na26-syncFade__pic');

                if (entry.isIntersecting) {
                    svTexts.forEach(el => el.classList.add('js-show'));
                    svPics.forEach(el => el.classList.add('js-show'));
                    svObserver.unobserve(svCover);
                }
            });
        },
        {
            threshold: 0.01
        }
    );

    svCovers.forEach(svCover => svObserver.observe(svCover));
}

function initModalSwiperFeatures() {
    function manageSlideClassesNextNext(swiper) {
        const activeIndex = swiper.activeIndex;
        const slides = swiper.slides;
        const totalSlides = slides.length;

        slides.forEach(slide => {
            slide.classList.remove('js-na26Modal__sec__in__swp__slide--next-next');
        });

        const nextNextIndex = (activeIndex + 2) % totalSlides;
        const nextNextSlide = slides[nextNextIndex];

        if (nextNextSlide) {
            nextNextSlide.classList.add('js-na26Modal__sec__in__swp__slide--next-next');
        }
    }

    function initializePagination(container, swiper) {
        const paginationCount = container.querySelector('.js-na26Modal__sec__in__swp__pagination__count');
        if (!paginationCount) return;

        const totalSlides = swiper.slides.length;

        paginationCount.innerHTML = '';

        for (let i = 1; i <= totalSlides; i++) {
            const numElement = document.createElement('span');
            numElement.classList.add('na26Modal__sec__in__swp__pagination__count__num');

            if (i === 1) {
                numElement.classList.add('is-active');
            }

            numElement.textContent = i.toString().padStart(2, '0');
            paginationCount.appendChild(numElement);
        }

        const paginationLength = document.createElement('div');
        paginationLength.classList.add(
            'js-na26Modal__sec__in__swp__pagination__count__length',
            'na26Modal__sec__in__swp__pagination__count__length'
        );
        paginationLength.textContent = `/${totalSlides.toString().padStart(2, '0')}`;
        paginationCount.appendChild(paginationLength);
    }

    function updatePagination(container, swiper) {
        const paginationCount = container.querySelector('.na26Modal__sec__in__swp__pagination__count');
        const currentSlideIndex = swiper.realIndex;

        if (!paginationCount) return;

        const numElements = paginationCount.querySelectorAll('.na26Modal__sec__in__swp__pagination__count__num');

        numElements.forEach((el, index) => {
            if (index === currentSlideIndex) {
                el.classList.add('is-active');
                el.classList.remove('is-out');
            } else if (el.classList.contains('is-active')) {
                el.classList.remove('is-active');
                el.classList.add('is-out');
            } else {
                el.classList.remove('is-out');
            }
        });
    }

    function updateActiveButton(activeIndex, group) {
        const buttons = group.querySelectorAll('.js-na26Modal__model__sec__varNav__btn');

        buttons.forEach((btn, i) => {
            btn.classList.toggle('is-active', i === activeIndex);
        });
    }

    function modelSwiper(modal) {
        const isMobile = window.innerWidth <= 1023;

        modal.querySelectorAll('.js-na26-parent').forEach(group => {
            const container = group.querySelector('.js-na26Modal__model__sec__swp');
            if (!container) return;

            const innerContainer = container.querySelector('.js-na26Modal__model__sec__swp__in');
            if (!innerContainer) return;

            const isInitialized = innerContainer.classList.contains('swiper-initialized');

            if (isMobile) {
                if (isInitialized) {
                    innerContainer.swiper?.update?.();
                } else {
                    const swiper = new Swiper(innerContainer, {
                        loop: false,
                        speed: 800,
                        slidesPerView: 1,
                        navigation: {
                            prevEl: container.querySelector('.na26Modal__model__sec__swp__prev'),
                            nextEl: container.querySelector('.na26Modal__model__sec__swp__next')
                        },
                        scrollbar: {
                            el: container.querySelector('.na26Modal__model__sec__swp__scrollbar'),
                            draggable: true
                        },
                        on: {
                            slideChange: function () {
                                updateActiveButton(swiper.realIndex, group);
                            }
                        }
                    });

                    const buttons = group.querySelectorAll('.js-na26Modal__model__sec__varNav__btn');
                    buttons.forEach((btn, i) => {
                        btn.addEventListener('click', () => {
                            swiper.slideToLoop(i);
                            updateActiveButton(i, group);
                        });
                    });

                    updateActiveButton(swiper.realIndex, group);
                }
            } else {
                if (isInitialized && innerContainer.swiper) {
                    innerContainer.swiper.destroy(true, true);
                }
            }
        });
    }

    function relatedSwiper() {
        document.querySelectorAll('.js-na26Modal__related__swp').forEach(container => {
            if (container.classList.contains('swiper-initialized')) return;

            new Swiper(container, {
                slidesPerView: 1.737,
                loop: false,
                freeMode: true,
                mousewheel: {
                    forceToAxis: true,
                    sensitivity: 3
                },
                spaceBetween: 10,
                breakpoints: {
                    768: {
                        slidesPerView: 2.5
                    },
                    1024: {
                        slidesPerView: 5.618
                    }
                }
            });
        });
    }

    function refreshModalSwipers(modal) {
        if (!modal) return;

        const hiddenBlocks = modal.querySelectorAll('.js-na26Modal-none-block');
        hiddenBlocks.forEach(el => {
            el.classList.add('is-visible');
        });

        modelSwiper(modal);
        relatedSwiper();

        const swiperContainers = modal.querySelectorAll('.js-na26Modal__sec__in__swp');

        swiperContainers.forEach(swiperContainer => {
            if (swiperContainer.classList.contains('swiper-initialized') && swiperContainer.swiper) {
                try {
                    swiperContainer.swiper.destroy(true, true);
                } catch (e) {
                    console.warn('Swiper destroy failed:', e);
                }
            }

            const paginationCount = swiperContainer.querySelector('.js-na26Modal__sec__in__swp__pagination__count');
            if (paginationCount) {
                paginationCount.innerHTML = '';
            }

            swiperContainer.querySelectorAll('.na26Modal__sec__in__swp__slide').forEach((slide, index) => {
                slide.classList.remove('js-na26Modal__sec__in__swp__slide--first');
                if (index === 0) {
                    slide.classList.add('js-na26Modal__sec__in__swp__slide--first');
                }
            });

            const swiper = new Swiper(swiperContainer, {
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                loop: true,
                speed: 100,
                preventInteractionOnTransition: true,
                slidesPerView: 1,
                effect: 'fade',
                slideActiveClass: 'swiper-slide-active--main',
                navigation: {
                    nextEl: swiperContainer.querySelector('.js-na26Modal__sec__in__swp__pagination__next')
                },
                pagination: {
                    el: swiperContainer.querySelector('.swiper-pagination'),
                    clickable: true
                },
                on: {
                    init: function () {
                        const bullets = swiperContainer.querySelectorAll('.swiper-pagination-bullet');
                        bullets.forEach((b, index) => b.setAttribute('data-index', index + 1));
                        initializePagination(swiperContainer, this);
                        manageSlideClassesNextNext(this);

                        if (this.autoplay && typeof this.autoplay.start === 'function') {
                            this.autoplay.start();
                        }
                    },
                    slideChange: function () {
                        const bullets = swiperContainer.querySelectorAll('.swiper-pagination-bullet');
                        const activeBullet = swiperContainer.querySelector('.swiper-pagination-bullet-active');

                        if (activeBullet?.getAttribute('data-index') === '1') {
                            bullets.forEach(b => b.classList.remove('done', 'start'));
                        } else if (activeBullet?.previousElementSibling) {
                            activeBullet.previousElementSibling.classList.add('done');
                        }

                        if (activeBullet) {
                            activeBullet.classList.remove('done');
                            activeBullet.classList.add('start');
                        }

                        const firstMainSlide = swiperContainer.querySelector('.js-na26Modal__sec__in__swp__slide--first');
                        if (this.realIndex === 1 && firstMainSlide) {
                            firstMainSlide.classList.remove('js-na26Modal__sec__in__swp__slide--first');
                        }

                        manageSlideClassesNextNext(this);
                        updatePagination(swiperContainer, this);
                    }
                }
            });

            const imgs = swiperContainer.querySelectorAll('img');
            imgs.forEach(img => {
                if (!img.complete) {
                    img.addEventListener('load', () => {
                        swiper.update();
                    }, { once: true });
                }
            });
        });
    }

    window.addEventListener('resize', () => {
        document.querySelectorAll('.js-c-modalCnt').forEach(modal => {
            refreshModalSwipers(modal);
        });
    });

    document.querySelectorAll('.js-c-modalCnt').forEach(modal => {
        const scrollContainer = modal.querySelector('.c-modalCnt__in');
        const hiddenBlocks = modal.querySelectorAll('.js-na26Modal-none-block');

        if (!scrollContainer || hiddenBlocks.length === 0) return;

        if (scrollContainer.dataset.na26ArtScrollRegistered === 'true') return;
        scrollContainer.dataset.na26ArtScrollRegistered = 'true';

        function onModalScrollOnce() {
            scrollContainer.removeEventListener('scroll', onModalScrollOnce);
            refreshModalSwipers(modal);
        }

        scrollContainer.addEventListener('scroll', onModalScrollOnce);
    });

    document.querySelectorAll('.js-c-modalOpen').forEach(btn => {
        btn.addEventListener('click', () => {
            const modalId = btn.dataset.modal;
            if (!modalId) return;

            const modal =
                document.querySelector(`.js-c-modalCnt[data-modal="${modalId}"]`) ||
                document.getElementById(modalId);

            if (!modal) return;

            requestAnimationFrame(() => {
                setTimeout(() => {
                    refreshModalSwipers(modal);
                }, 60);
            });
        });
    });

    document.addEventListener('lazyloaded', e => {
        const swiperContainer = e.target.closest('.js-na26Modal__sec__in__swp');
        if (swiperContainer && swiperContainer.swiper) {
            swiperContainer.swiper.update();
        }
    });
}

function initCursor() {
    const cursor = document.getElementById('js-cursor');
    if (!cursor) return;

    const cWidth = 8;
    const delay = 10;
    let mouseX = 0;
    let mouseY = 0;
    let posX = 0;
    let posY = 0;
    let hasLoaded = false;

    TweenMax.to({}, 0.001, {
        repeat: -1,
        onRepeat: function () {
            posX += (mouseX - posX) / delay;
            posY += (mouseY - posY) / delay;

            TweenMax.set(cursor, {
                css: {
                    left: mouseX - (cWidth / 2),
                    top: mouseY - (cWidth / 2)
                }
            });
        }
    });

    document.addEventListener('mousemove', function (e) {
        mouseX = e.clientX;
        mouseY = e.clientY;

        if (!hasLoaded) {
            cursor.classList.add('js-loaded');
            hasLoaded = true;
        }
    });

    function bindCursorLinkHover(elements) {
        if (!elements) return;
        // 単体だったら配列化
        if (!elements.length) {
            elements = [elements];
        }
        // NodeList
        elements.forEach(el => {
            el.addEventListener('mouseenter', () => {
                cursor.classList.add('is-link');
            });

            el.addEventListener('mouseleave', () => {
                cursor.classList.remove('is-link');
            });
        });
    }

    bindCursorLinkHover(document.querySelectorAll('a'));
    bindCursorLinkHover(document.getElementById('js-c-modalClose__cross'));
    bindCursorLinkHover(document.getElementById('js-awsHeader__icon__in__blk--search'));
    bindCursorLinkHover(document.getElementById('js-awsHeader__pc__menu__cnt__in__sticky__close'));
    bindCursorLinkHover(document.querySelector('.headerSearch__modal__inner__btn-close'));
    bindCursorLinkHover(document.querySelector('.search__modal__inner__form__btn'));
    bindCursorLinkHover(document.querySelectorAll('.js-na26Modal__sec__in__swp__pagination__next'));
}

function initClickProtection() {
    const buttons = document.querySelectorAll('.js-clickProtection');
    if (!buttons.length) return;

    let timer = null;

    buttons.forEach(button => {
        button.addEventListener('click', () => {
            buttons.forEach(btn => {
                btn.classList.add('is-disabled');
            });

            clearTimeout(timer);
            timer = setTimeout(() => {
                buttons.forEach(btn => {
                    btn.classList.remove('is-disabled');
                });
            }, 1000);
        });
    });
}

function fixInitialHashScroll() {
    const hash = window.location.hash;
    if (!hash) return;

    const target = document.querySelector(hash);
    if (!target) return;

    // レイアウト確定後に再度スクロール
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            setTimeout(() => {
                target.scrollIntoView({
                    behavior: 'auto',
                    block: 'start'
                });
            }, 250);
        });
    });
}